<template>
  <b-container fluid>
    <b-row id="recipe-header" class="row justify-content-center mb-5">
          <b-col cols="11">
            <b-row align-h="between">
              <b-col md="6">
                <a href="/">
                  <img alt="gravity logo" src="../../assets/logo.png" />
                </a>
              </b-col>
              <b-col md="6" xs="3" class="started-button d-none d-sm-block">
                <a href="https://www.getrocketsignals.com/demo">
                  <b-button class="button-white-transparent">
                    Request Demo
                  </b-button>
                </a>
              </b-col>
            </b-row>
            <b-row align-h="start" class="text-content">
              <b-col>
                <h1 class="text-white title text-left">Fastest Growing {department} team in {location}.</h1>
              </b-col>
            </b-row>
            <b-row align-h="start">
              <b-col class="mt-2">
                <h4 class="text-white text-left" md="6">
                  <b>Out of {count} companies in {location} here are the top 5. </b>
                </h4>

              </b-col>
            </b-row>


            <b-row align-h="start">
              <b-col
                cols="12"
                md="6"
                class="d-flex mt-5 justify-content-center justify-content-md-start"
              >
                <a href="https://www.getrocketsignals.com/demo">
                  <b-button class="button-white-transparent">
                    Get Company Data
                  </b-button>
                </a>

              </b-col>
            </b-row>

          </b-col>
        </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/home/header.sass
</style>

<script>

import VueScrollTo from 'vue-scrollto';

export default {
  name: 'Header',
  methods: {
    scrollFix: function(hash) {
      console.log('Scroll To')
      VueScrollTo.scrollTo(hash, 3000)
    },

  },
}
</script>
